export const getFieldErrorMessage = ({ errorMessage, errors, touched, name }) => {
  if (errorMessage) {
    return errorMessage
  }

  return errors[name] && touched[name] ? errors[name] : null
}
